import { Checkbox, Image, UIHeading4, UIText1 } from '@cian/ui-kit';
import classNames from 'clsx';
import * as React from 'react';

import * as style from './OffersPickerSelectionItem.css';
import { IOfferSchema } from '../../repositories/chats/entities/get_my_offers_for_selection/OfferSchema';
import { ImageNone } from '../ImageNone';

interface IProps {
  isReachedLimit: boolean;
  isFirstInList: boolean;
  selectedIds: Array<number>;
  offer: IOfferSchema;
  onSelect(value: IOfferSchema): void;
}

export const OffersPickerSelectionItem = ({ selectedIds, isFirstInList, isReachedLimit, offer, onSelect }: IProps) => {
  const { realtyOfferId, photoUrl, formattedAddress, formattedInfo, formattedPrice } = offer;
  const isSelected = selectedIds.includes(realtyOfferId);

  return (
    <div className={classNames(style['offer'], isSelected && style['offer--selected'])}>
      {isReachedLimit && !isSelected && <div className={style['offer--disabled']} />}
      <Checkbox
        data-name="OfferPickerItem_checkbox"
        value={String(realtyOfferId)}
        onChange={() => onSelect(offer)}
        checked={isSelected}
        disabled={!isSelected && isReachedLimit}
      />
      <div className={classNames(style['offer-info'], isFirstInList && style['no-divide'])}>
        <div className={style['image']}>
          {photoUrl ? <Image alt="Фото объявления" src={photoUrl} /> : <ImageNone type="offer" />}
        </div>
        <div className={style['content']}>
          <UIHeading4>{formattedPrice}</UIHeading4>
          <UIText1>{formattedInfo}</UIText1>
          <UIText1>{formattedAddress}</UIText1>
        </div>
      </div>
    </div>
  );
};
